import { render } from "./Blog.vue?vue&type=template&id=83fdba32&scoped=true"
import script from "../js/blog.js?vue&type=script&lang=js&external"
export * from "../js/blog.js?vue&type=script&lang=js&external"

import "./Blog.vue?vue&type=style&index=0&id=83fdba32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83fdba32"]])

export default __exports__